export default __webpack_public_path__ + "static/media/01.fa55693e.png";